import React, { Component } from "react";
import Cookies from "universal-cookie";
import { withRouter } from "../../hoc/withRouter";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectBiro extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {
      listServiceBureau: JSON.parse(atob(this.cookies.get("_bbn_ls"))) || {},
    };
  }

  // Ambil kode biro dari path (misal dari "/PTAS/dashboard")
  getSelectedBiroFromPath = () => {
    const path = this.props.location.pathname;
    const match = path.match(/^\/([^/]+)/); // ambil setelah slash pertama
    return match ? match[1] : null;
  };

  setOptionServiceBureau = () => {
    const { listServiceBureau } = this.state;
    return Object.entries(listServiceBureau).map(([code, row]) => {
      const serviceBureauName = row.replace(/Biro |Jasa /g, "").toUpperCase();
      return (
        <Option key={code} value={code}>
          {serviceBureauName}
        </Option>
      );
    });
  };

  changeServiceBureau = (value) => {
    const { listServiceBureau } = this.state;
    if (listServiceBureau[value]) {
      if (this.props.onChangeBiro) {
        this.props.onChangeBiro(value);
      }
      this.props.history.push(`/${value}/dashboard`);
    } else {
      this.logout();
    }
  };

  logout = () => {
    const { history } = this.props;

    this.cookies.remove("_bbn_tn");
    this.cookies.remove("_bbn_un");
    this.cookies.remove("_bbn_ls");
    this.cookies.remove("_bbn_df");
    this.cookies.remove("_bbn_m");

    const bc = new BroadcastChannel("logout_channel");
    bc.postMessage("logout");
    bc.close();
    history.push("/login");
  };

  render() {
    const selectedBiro = this.getSelectedBiroFromPath();
    return (
      <Form.Item>
        <Select value={selectedBiro} onChange={this.changeServiceBureau} style={{ fontSize: "90%", minWidth: 250 }}>
          {this.setOptionServiceBureau()}
        </Select>
      </Form.Item>
    );
  }
}

export default withRouter(SelectBiro);
